import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle, ArrowRight, X } from "@phosphor-icons/react";

export default function Onboarding() {
  const [data, setData] = useState(null);
  const nav = useNavigate();
  useEffect(() => { api.get("/onboarding/status").then(r => setData(r.data)); }, []);

  if (!data) return <div className="p-8 text-[12px]">Loading…</div>;

  const dismiss = async () => {
    await api.post("/onboarding/dismiss");
    nav("/dashboard");
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[var(--span-surface-2)]">
      <div className="card-flat p-7 max-w-xl w-full" data-testid="onboarding-page">
        <div className="flex items-start justify-between mb-2">
          <div>
            <div className="label-eyebrow">Getting started</div>
            <h1 className="font-display font-bold text-2xl mt-1">Welcome to SPAN</h1>
            <div className="text-[12px] text-[var(--span-text-2)] mt-1">{data.completed} of {data.total} steps complete · {data.completion_pct}%</div>
          </div>
          <button data-testid="onboarding-dismiss" onClick={dismiss} title="Skip onboarding" className="text-[var(--span-text-2)] hover:text-black"><X size={18}/></button>
        </div>
        <div className="h-1 bg-[var(--span-surface-3)] mt-3 mb-5">
          <div className="h-1 bg-[var(--span-accent)]" style={{width:`${data.completion_pct}%`}} data-testid="onboarding-progress"/>
        </div>
        <ul className="space-y-2">
          {data.steps.map(s => (
            <li key={s.id} className="hairline p-3 flex items-center gap-3" data-testid={`onboarding-step-${s.id}`}>
              <div className={`w-6 h-6 rounded-full flex items-center justify-center text-[10px] ${s.done ? "bg-emerald-500 text-white" : "bg-[var(--span-surface-3)] text-[var(--span-text-2)]"}`}>
                {s.done ? <CheckCircle size={14} weight="fill"/> : "·"}
              </div>
              <div className="flex-1 text-[13px]">{s.label}</div>
              <button onClick={() => nav(s.link)} className="text-[10px] hairline px-2 py-1 hover:bg-[var(--span-surface-3)]">
                {s.done ? "Re-open" : "Start"} <ArrowRight size={10} className="inline ml-1"/>
              </button>
            </li>
          ))}
        </ul>
        <div className="text-[10px] text-[var(--span-text-2)] text-center mt-5">
          Skip anytime — re-open via Settings → Onboarding.
        </div>
      </div>
    </div>
  );
}
